import React from 'react';
import styled, { css } from 'styled-components';
import Pagination from '../Pagination';

export interface CardsGridProps {
  children: React.ReactNode[];
  columns: 2 | 3;
  pagination?: {
    page: number;
    totalPages: number;
    nextText: string;
    prevText: string;
    getPageUrl: (page: number) => string;
  }
}

const Grid = styled.div<{ columns: 2 | 3 }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  gap: 32px;

  @media (max-width: ${({ theme }) => theme.breakpoints.large}) {
    gap: 24px;
  }

  ${({ columns }) => (columns === 2 ? css`
    // 2 columns
    @media (max-width: ${({ theme }) => theme.breakpoints.medium}) {
        grid-template-columns: 1fr;
    }
  ` : css`
    // 3 columns
    @media (max-width: ${({ theme }) => theme.breakpoints.large}) {
      grid-template-columns: 1fr;
    }
  `)}
`;

const GridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const CardGrid: React.FC<CardsGridProps> = (props) => (
  <GridWrapper>
    <Grid columns={props.columns}>
      {props.children}
    </Grid>
    {props.pagination && (
      <Pagination
        currentPage={props.pagination.page}
        totalPages={Math.ceil(props.pagination.totalPages)}
        nextText={props.pagination.nextText}
        previousText={props.pagination.prevText}
        getPageUrl={props.pagination.getPageUrl}
      />
    )}
  </GridWrapper>
);

export default CardGrid;
